import { type ReactElement } from 'react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@front/model'
import { Page, TButton } from '@components'

function ExportMoved(): ReactElement {
  const { t } = useTranslation()

  return (
    <Page>
      <Page.Content>
        <Page.Hero
          icon='file_export'
          title={t('Export has moved')}
          description={t('Export is now under the Integrations tab.')}
        >
          <TButton component={Link} to='/integration/export'>
            {t('Go to Export')}
          </TButton>
        </Page.Hero>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/export/')({
  component: ExportMoved,
})
